import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IResUPS, UPSProfile } from '@/types/ups';

interface UpsState {
  profile: UPSProfile | null;
  loading: boolean;
  error: string | null;
}

const initialState: UpsState = {
  profile: null,
  loading: false,
  error: null,
};

const upsSlice = createSlice({
  name: 'ups',
  initialState,
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    error: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUPSProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUPSProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.profile = (action.payload as IResUPS<UPSProfile>).data;
      })
      .addCase(getUPSProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { loading, error } = upsSlice.actions;

export const getUPSProfile = createAsyncThunk(
  'ups/getUPSProfile',
  async (_, { rejectWithValue }) => {
    try {
      const http = initializeHttpProvider();
      const res = await http.ups.profile();
      return res;
    } catch {
      return rejectWithValue('Error al obtener el perfil');
    }
  },
);

export default upsSlice.reducer;
